<template>
  <LocalIndex />
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'center'
})

useHead({
  title: '가이드'
})

const { ogUrl, ogTitle } = useSeo()

useSeoMeta({
  title: 'eSIM 현지 설치 가이드',
  description:
    '현지 설치가 가능한 eSIM의 설치, 활성화하는 방법을 알려드릴게요!',
  ogType: 'website',
  ogUrl: () => ogUrl('guide/local'),
  ogTitle: () => ogTitle('eSIM 현지 설치 가이드'),
  ogDescription:
    '현지 설치가 가능한 eSIM의 설치, 활성화하는 방법을 알려드릴게요!',
  twitterCard: 'summary',
  twitterTitle: () => ogTitle('eSIM 현지 설치 가이드'),
  twitterDescription:
    '현지 설치가 가능한 eSIM의 설치, 활성화하는 방법을 알려드릴게요!',
  keywords:
    'eSIM,해외이심,해외eSIM,아이폰 eSIM, 아이폰이심, 갤럭시 eSIM, 갤럭시이심, 유심사,eSIM설치, eSIM활성화, eSIM제거, 가이드, eSIM가이드,이심가이드, 현지설치, 설정, 세팅'
})
</script>